export default __webpack_public_path__ + "static/media/KOD0099-min.a939f795.webp";